import styled from "styled-components";

export const TooltipContainer = styled.div`
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    overflow: hidden;
`;

/** Bolha do tooltip quando renderizada via Portal (position: fixed) */
export const TooltipBubblePortal = styled.div<{ longContent?: boolean; side?: "top" | "left"; $centerAboveTrigger?: boolean; $alignStart?: boolean }>`
    position: fixed;
    width: ${({ longContent }) => (longContent ? "min(320px, 90vw)" : "auto")};
    min-width: ${({ longContent }) => (longContent ? "min(240px, 90vw)" : "auto")};
    max-width: ${({ longContent }) => (longContent ? "min(320px, 90vw)" : "none")};
    background: ${({ theme }) => theme.colors?.interfaceGray700 || "#333"};
    color: ${({ theme }) => theme.colors?.interfacePure0 || "#fff"};
    font-size: 12px;
    font-weight: 600;
    padding: 6px 10px;
    border-radius: 8px;
    white-space: ${({ longContent }) => (longContent ? "normal" : "nowrap")};
    overflow-wrap: ${({ longContent }) => (longContent ? "break-word" : "normal")};
    word-break: ${({ longContent }) => (longContent ? "normal" : "normal")};
    box-sizing: border-box;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    z-index: 9999;
    pointer-events: none;

    &::after {
        content: "";
        position: absolute;
        border-width: 6px;
        border-style: solid;
        display: block;
        ${({ side, theme, $centerAboveTrigger, $alignStart }) =>
            side === "left"
                ? `
            top: 50%;
            left: 100%;
            transform: translateY(-50%);
            border-color: transparent transparent transparent ${theme.colors?.interfaceGray700 || "#333"};
        `
                : `
            top: 100%;
            left: ${$alignStart ? "16px" : $centerAboveTrigger ? "50%" : "16px"};
            transform: ${$alignStart ? "none" : $centerAboveTrigger ? "translateX(-50%)" : "none"};
            border-color: ${theme.colors?.interfaceGray700 || "#333"} transparent transparent transparent;
        `}
    }
`;

export const TooltipBubble = styled.div<{ longContent?: boolean }>`
    position: absolute;
    bottom: calc(100% + 8px);
    left: ${({ longContent }) => (longContent ? "0" : "50%")};
    transform: ${({ longContent }) => (longContent ? "none" : "translateX(-50%)")};
    width: ${({ longContent }) => (longContent ? "min(320px, 90vw)" : "auto")};
    min-width: ${({ longContent }) => (longContent ? "min(240px, 90vw)" : "auto")};
    max-width: ${({ longContent }) => (longContent ? "min(320px, 90vw)" : "none")};
    background: ${({ theme }) => theme.colors?.interfaceGray700 || "#333"};
    color: ${({ theme }) => theme.colors?.interfacePure0 || "#fff"};
    font-size: 12px;
    font-weight: 600;
    padding: 6px 10px;
    border-radius: 8px;
    white-space: ${({ longContent }) => (longContent ? "normal" : "nowrap")};
    overflow-wrap: ${({ longContent }) => (longContent ? "break-word" : "normal")};
    word-break: ${({ longContent }) => (longContent ? "normal" : "normal")};
    box-sizing: border-box;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    z-index: 20;

    &::after {
        content: "";
        position: absolute;
        top: 100%;
        left: ${({ longContent }) => (longContent ? "16px" : "50%")};
        transform: ${({ longContent }) => (longContent ? "none" : "translateX(-50%)")};
        border-width: 6px;
        border-style: solid;
        border-color: ${({ theme }) => theme.colors?.interfaceGray700 || "#333"} transparent transparent transparent;
    }
`;
